import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.module.scss';


class KnowYourValueLogo extends React.Component {
  static propTypes = {
    color: PropTypes.string.isRequired,
    active: PropTypes.bool,
  };

  static defaultProps = {
    active: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { active } = this.props;

    if (!active && nextProps.active) {
      // Manual Animation for source switch.
      setTimeout(() => {
        this.setState({ isActive: true });
      }, 1000);
    } else if (active && !nextProps.active) {
      this.setState({ isActive: false });
    }
  }

  svg = () => (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 800 240">
      <g>
        <g>
          <path d="M105.3,126.4h0.2l12.8-15.7h15.9l-18.1,18.8l19.5,24h-16.1l-14-18.2h-0.2v18.2H93.1v-74h12.2V126.4z" />
          <path d="M231.2,132.1c0,13.3-9.1,22.8-22.5,22.8s-22.5-9.5-22.5-22.8c0-13.4,9.2-22.9,22.5-22.9S231.2,118.8,231.2,132.1z M198.6,132.1c0,5.8,3.8,12,10.1,12s10.1-6.2,10.1-12c0-5.9-3.8-12-10.1-12S198.6,126.2,198.6,132.1z" />
          <path d="M255,135.4l10.5-26.1h5.8l10.6,26.4l9.1-25h13.3l-19.9,43.7h-6.2l-9.2-26.1l-10.2,26.1h-6.3l-19.7-43.7h13.4L255,135.4z" />
          <path d="M166.7,153.5v-23.2c0-4.9-0.8-10.7-7-10.7s-7,5.8-7,10.7v23.2h-12.2v-25.2c0-12.5,6.5-19,19.2-19s19.2,6.5,19.2,19v25.2H166.7z" />
        </g>
        <path d="M317.8,110.2h13.9l10.2,24.3l11-24.3h13.6l-31.2,65.7h-13.4l14.1-29.4L317.8,110.2z" />
        <path d="M410.5,131.6c0,13.3-9.1,22.8-22.5,22.8c-13.4,0-22.5-9.5-22.5-22.8c0-13.4,9.2-22.9,22.5-22.9C401.3,108.8,410.5,118.3,410.5,131.6z M377.9,131.6c0,5.8,3.8,12,10.1,12c6.3,0,10.1-6.2,10.1-12c0-5.9-3.8-12-10.1-12C381.7,119.6,377.9,125.7,377.9,131.6z" />
        <path d="M428.5,110.2v23.2c0,4.9,0.8,10.7,7,10.7c6.2,0,7-5.8,7-10.7v-23.2h12.2v25.2c0,12.5-6.5,19-19.2,19c-12.7,0-19.2-6.5-19.2-19v-25.2H428.5z" />
        <path d="M477.2,114.6h0.2c2.4-3.8,6.1-5.8,10.6-5.8c1.7,0,3.5,0.4,5.1,1l-1.5,11.3c-1.5-1-3.2-1.6-5.1-1.6c-8.5,0-9.3,7.5-9.3,14.1V153H465v-42.8h12.2V114.6z" />
        <path d="M531.6,133l8.8-24.2h13.4l-19.7,43.7h-6.3l-19.6-43.7h13.4L531.6,133z" />
        <path d="M597,151.6h-12v-3.9h-0.2c-2.6,3.4-7.2,5.3-11.6,5.3c-12.6,0-19.7-11.4-19.7-23c0-11.3,7.2-22.6,19.5-22.6c4.5,0,9,1.9,12,5.4v-4h12V151.6z M586.1,130.2c0-5.8-3.9-12-10.2-12c-6.3,0-10.1,6.2-10.1,12c0,5.8,3.8,12,10.1,12C582.2,142.2,586.1,135.9,586.1,130.2z" />
        <path d="M619.7,151.6h-12.2V79.5h12.2V151.6z" />
        <path d="M642.1,108.8V132c0,4.9,0.8,10.7,7,10.7s7-5.8,7-10.7v-23.2h12.2V134c0,12.5-6.5,19-19.2,19s-19.2-6.5-19.2-19v-25.2H642.1z" />
        <path d="M688.4,132.2c0,5.4,2.1,11.5,8.5,11.5c4,0,6.5-2.4,8.2-5.8l11.3,1.8c-3,8.6-10.5,13.4-19.5,13.4c-13.3,0-21.4-9.4-21.4-22.4c0-13,6.9-23.2,20.8-23.2c14,0,20.3,10.4,20.3,23.3v1.5H688.4z M705.1,124.6c-0.6-4.4-3.4-8.6-8.1-8.6c-4.9,0-7.6,4.2-8.2,8.6H705.1z" />
        <g>
          <polygon points="83.4,199 46.4,199 46.4,41 83.4,41 83.4,51 56.4,51 56.4,189 83.4,189" />
        </g>
        <g>
          <polygon points="753.6,199 716.6,199 716.6,189 743.6,189 743.6,51 716.6,51 716.6,41 753.6,41" />
        </g>
      </g>
    </svg>
  );

  render() {
    const { isActive } = this.state;
    const { color } = this.props;

    const logoClasses = classNames(
      styles.logo,
      {
        [styles.white]: isActive || color !== 'black',
      },
    );

    return (
      <span className={logoClasses}>
        {this.svg()}
      </span>
    );
  }
}

export default KnowYourValueLogo;
